// jsaForm/core/racInfo.actions.js

export const makeJsaCoreRacInfoActions = ({ bump, emitJsaPatch }) => ({
  updateJsaRacAccessPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacAccessPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacAccessPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacAccessElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacAccessElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacAccessElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacAccessCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacAccessCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacAccessCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacChemicalPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacChemicalPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacChemicalPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacChemicalElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacChemicalElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacChemicalElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacChemicalCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacChemicalCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacChemicalCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacEnvironmentPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacEnvironmentPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacEnvironmentPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacEnvironmentElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacEnvironmentElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacEnvironmentElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacEnvironmentCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacEnvironmentCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacEnvironmentCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacPhysicalPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPhysicalPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPhysicalPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacPhysicalElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPhysicalElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPhysicalElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacPhysicalCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPhysicalCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPhysicalCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacPotEnergyPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPotEnergyPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPotEnergyPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacPotEnergyElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPotEnergyElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPotEnergyElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacPotEnergyCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacPotEnergyCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacPotEnergyCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacToolsPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacToolsPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacToolsPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacToolsElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacToolsElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacToolsElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacToolsCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacToolsCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacToolsCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateJsaRacOtherPotHazInfo(jsaData, potHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacOtherPotHazInfo(potHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacOtherPotHazInfo: potHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacOtherElimHazInfo(jsaData, elimHazInfo, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacOtherElimHazInfo(elimHazInfo);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacOtherElimHazInfo: elimHazInfo }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateJsaRacOtherCode(jsaData, code, emitPatch) {
    jsaData.jsaRacInfo.updateJsaRacOtherCode(code);
    if (emitPatch) {
      const patch = jsaData.jsaRacInfo.toPatch({ jsaRacOtherCode: code }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
